import { CardContent, Grid, Typography } from '@mui/material';
import React from 'react';
import FileDownload from '../common/FileDownload';
import { FileUploadGradingQuestion } from './GradingQuestionType';
import { GradingQuestionAction } from './GradingQuestionReducer';
import GradingQuestionInput from './GradingQuestionInput';
import { useParams } from 'react-router-dom';

interface FileUploadGradingCardProps {
  data: FileUploadGradingQuestion;
  dispatch: React.Dispatch<GradingQuestionAction>;
  isViewMode?: boolean;
}

const FileUploadGradingCard: React.FC<FileUploadGradingCardProps> = ({
  data,
  dispatch,
  isViewMode = false,
}) => {
  const { jobId, applicantId, assessmentId } = useParams();
  return (
    <CardContent
      sx={{
        marginTop: '24px',
        marginBottom: '12px',
        marginLeft: '48px',
        marginRight: '48px',
        position: 'relative',
      }}
    >
      <Typography variant="h6" sx={{ textAlign: 'left', fontWeight: 'bold' }}>
        {`Question ${data.questionIndex + 1}`}
      </Typography>
      <Grid>
        <Grid item>
          <Typography
            align="left"
            variant="body1"
            gutterBottom
            sx={{
              width: '80%',
            }}
          >
            {data.text}
          </Typography>
          <FileDownload
            // TODO: change this later
            url={`/metrics/jobs/${jobId}/applicants/${applicantId}/assessments/${assessmentId}/questions/${data.questionId}/answer/download`}
            displayedText="Download Answer"
          />
        </Grid>
        <GradingQuestionInput
          dispatch={dispatch}
          maxGrade={data.maxGrade}
          grade={data.grade}
          questionIndex={data.questionIndex}
          gradable={!isViewMode}
        />
      </Grid>
    </CardContent>
  );
};

export default FileUploadGradingCard;
